<template>
  <el-table
    style="width: 100%"
    :data="grouped"
    border
    size="mini"
    :show-header="false"
    empty-text="未設定"
    class="address-by-department"
  >
    <el-table-column property="group_name" width="200" class="group-name"> </el-table-column>
    <el-table-column show-overflow-tooltip class="menbers">
      <template #default="scope">
        {{ scope.row.members.join(', ') }}
      </template>
    </el-table-column>
  </el-table>
</template>

<script lang="ts">
import { defineComponent, PropType, computed } from 'vue'
import { MessageAddress } from '@/api'

interface GroupedAddress {
  department_id: number | null
  group_name: string
  members: string[]
}

/** 申請者表示名 */
const APPLICANT_DISPLAY = '申請者連絡先'

/**
 * 宛先を保守区ごとに表示するコンポーネント
 */
export default defineComponent({
  name: 'AddressByDepartment',
  props: {
    addresses: {
      type: Array as PropType<MessageAddress[]>,
      required: true,
    },
  },
  setup(props) {
    const grouped = computed(() => {
      // グループ結果
      const results: GroupedAddress[] = []

      // 全ての宛先をチェックし、グループ結果に入れていく
      props.addresses.forEach((address) => {
        if (address.is_applicant) {
          // 申請者の場合は先頭に追加。協議者は配列中に最大1件しか存在しない
          results.unshift({
            department_id: null,
            group_name: APPLICANT_DISPLAY,
            members: [address.email],
          })
        } else {
          // 社員の場合
          if (address.department == null || address.department_name == null || address.user_name == null) {
            // null除去
            return
          }
          // 既に結果に保守区グループが存在するか確認する
          const group = results.find((result) => result.department_id === address.department)

          if (group == null) {
            // まだ無い保守区の場合、保守区情報とユーザー名を追加する
            results.push({
              department_id: address.department,
              group_name: address.department_name,
              members: [address.user_name],
            })
          } else {
            // 既にある場合、そこにユーザー名を追加する
            group.members.push(address.user_name)
          }
        }
      })
      return results
    })

    return {
      grouped,
    }
  },
})
</script>

<style lang="scss" scoped>
/** 未設定の時の行サイズが大きいため、1行設定時と高さを合わせる */
.address-by-department {
  ::v-deep(.el-table__empty-block) {
    min-height: 36px;
    .el-table__empty-text {
      line-height: initial;
    }
  }
}
</style>
